import React, { createContext } from 'react';

// Create a context for invoice management
export const InvoiceContext = createContext({
    invoice: {
        customer: null,
        dueDate: '',
        notes: '',
        items: [],
        subtotal: 0,
        tax: 0,
        total: 0,
        automaticTaxEnabled: true
    },
    setInvoice: () => {}
});

/**
 * Invoice Context Provider Component
 * @param {Object} props 
 * @param {Object} props.initialInvoice - Initial invoice data
 * @param {React.ReactNode} props.children - Child components
 */
export const InvoiceProvider = ({ initialInvoice, children }) => {
    const [invoice, setInvoice] = React.useState(initialInvoice || {
        customer: null,
        dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        notes: '',
        items: [{ product: null, quantity: 1, price: 0, total: 0 }],
        subtotal: 0,
        tax: 0,
        total: 0,
        automaticTaxEnabled: true
    });

    return (
        <InvoiceContext.Provider value={{ invoice, setInvoice }}>
            {children}
        </InvoiceContext.Provider>
    );
};

export default InvoiceContext; 